import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/admin/supplier";

export default {

  // PROFILE
  getOtherSupplierList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/other_suppliers?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  otherSupplierStatusChange(id, status) {
    return Repository.put(`${resource}/other_supplier/${id}/${status}`)
  },
  createOtherSupplier(payload){
    return Repository.post(`${resource}/other_suppliers`, payload)
  },
  getOtherSupplierProfile(id) {
    return Repository.get(`${resource}/other_suppliers/${id}`)
  },
  updateOtherSupplierProfile(id, payload) {
    return Repository.put(`${resource}/other_suppliers/${id}`, payload)
  },

  // SERVICES
  getServices(id) {
    return Repository.get(`${resource}/other_supplier_services/${id}`)
  },
  getListOfServices(supplier_id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    // filter[supplier-ids]=[${supplier_id}]
    return Repository.get(`${resource}/other_supplier_services?${supplier_id ? 'filter[supplier-ids]=' + supplier_id : ''}paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getAllListOfServices(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/other_supplier_service_list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createServices(payload) {
    return Repository.post(`${resource}/other_supplier_services`, payload)
  },
  deleteServices(id) {
    return Repository.delete(`${resource}/other_supplier_services/${id}`)
  },
  updateServices(id, payload) {
    return Repository.put(`${resource}/other_supplier_services/${id}`, payload)
  },

  // Orders
  getListOfServicesOrders(id, pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/other_supplier_orders?supplier_id=${id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getListOfAllServicesOrders(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/other_supplier_order_list?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createSupplierServicesOrder(payload) {
    return Repository.post(`${resource}/other_supplier_orders`, payload)
  },
  updateSupplierServicesOrder(id, payload) {
    return Repository.put(`${resource}/other_supplier_orders/${id}`, payload)
  },
  getSupplierServiceOrder(id) {
    return Repository.get(`${resource}/other_supplier_orders/${id}`)
  },
  statusChangeSupplierServicesOrder(id, status){
    return Repository.put(`${resource}/other_supplier_order/${id}/${status}`)
  },
  getOtherOrderPdfData(id) {
    return Repository.get(`${resource}/other_supplier_order/${id}/po_pdf`)
  },
  sendOtherOrderPdf(id, payload) {
    return Repository.post(`${resource}/other_supplier_order/${id}/send-order-confirmation-pdf`, payload)
  },
  getOtherOrderPdfPublic(secret_code) {
    return Repository.get(`${resource}/other_supplier_order/${secret_code}/po-pdf-data`)
  },
  getOtherOrderInvoiceEmailLog(id) {
    return Repository.get(`${resource}/other_supplier_order/${id}/sent-email-logs`)
  },

  //Category
  getAllCategoryList() {
    return Repository.get(`${resource}/other_supplier_service_categories`)
  },
  createCategory(payload) {
    return Repository.post(`${resource}/other_supplier_service_categories`, payload)
  },
  deleteCategory(id) {
    return Repository.delete(`${resource}/other_supplier_service_categories/${id}`)
  },
  updateCategory(id, payload) {
    return Repository.put(`${resource}/other_supplier_service_categories/${id}`, payload)
  },
  getCategory(id) {
    return Repository.get(`${resource}/other_supplier_service_categories/${id}`)
  },

  // Supplier Users

  getOtherSupplierUserList(supplier_id) {
    return Repository.get(`${resource}/other-suppliers/users?supplier_id=${supplier_id}`)
  },
  
  getOtherSupplierUserDetails(id) {
    return Repository.get(`${resource}/other-suppliers/users/${id}`)
  },

  createOtherSupplierUser(payload){
    return Repository.post(`${resource}/other-suppliers/users`, payload)
  },

  updateOtherSupplierUser(id, payload){
    return Repository.put(`${resource}/other-suppliers/users/${id}`, payload)

  },

  changeOtherSupplierUserStatus(user_id, status){
    return Repository.put(`${resource}/users/${user_id}/${status}`)
  }

};
